export default __webpack_public_path__ + "static/media/misc-fireplaceA-768w.6cf10336.webp";